<!--代理商列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">合作伙伴</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model.trim="page.value" placeholder="根据条件搜索" @on-enter="getData">
          <Select v-model="page.cond" slot="prepend" style="width: 100px">
            <Option value="id">编号</Option>
            <Option value="agent_name">名称</Option>
            <Option value="tel">账号</Option>
            <Option value="address">地址</Option>
            <Option value="contacts_name">联系人</Option>
            <Option value="contacts_tel">联系电话</Option>
            <Option value="wx_code">微信账号</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Poptip trigger="hover" title="筛选" content="content" placement="left">
          <Button icon="md-list-box" style="margin: 0 0 1px 0"></Button>
          <div slot="content" class="group">
            <Button
              size="small"
              style="margin: 0 5px 5px 0"
              v-for="(item, index) in col"
              :key="index"
              :type="item.show ? 'primary' : 'default'"
              @click="item.show = !item.show"
            >
              <span>{{ item.title }}</span>
            </Button>
          </div>
        </Poptip>
        <div class="senior-search" @click="seniorSearch">高级搜索</div>
        <Select v-model="page.is_del" style="width: 100px">
          <Option :value="0" style="text-align: center">合作伙伴</Option>
          <Option :value="-1" style="text-align: center">审核列表</Option>
          <Option :value="1" style="text-align: center">禁用列表</Option>
        </Select>
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button type="primary" @click="$router.push({ name: 'agent-add' })"
          >新增合作伙伴</Button
        >
      </div>
    </div>
    <div class="tags">
      <Tag
        v-for="(item, index) in searchShow"
        :key="index"
        closable
        @on-close="searchShowDel(index)"
      >
        {{ item }}
      </Tag>
    </div>
    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-sort-change="tableSort"
      ></Table>
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="searchModal" title="高级搜索">
      <Row
        class="rowMargin"
        type="flex"
        justify="space-between"
        v-for="(item, index) in searchList"
        :key="index"
      >
        <Col :span="8">
          <Select v-model="item.cond">
            <Option v-for="(a, b) in searchItem" :value="a.cond" :key="b">{{
              a.title
            }}</Option>
          </Select>
        </Col>
        <Col :span="4">
          <Select v-model="item.type">
            <Option :value="0">等于</Option>
            <Option :value="1">包含</Option>
            <Option :value="2">不等于</Option>
          </Select>
        </Col>
        <Col :span="7">
          <div v-for="(a, b) in searchItem" :key="b">
            <div v-if="item.cond === a.cond && a.select">
              <Select v-model="item.value" placeholder="选择搜索值">
                <Option v-for="(s, si) in a.select" :key="si" :value="s.val">{{
                  s.title
                }}</Option>
              </Select>
            </div>
            <div v-if="item.cond === a.cond && !a.select">
              <Input v-model="item.value" placeholder="输入搜索值" />
            </div>
            <div v-if="!item.cond && b === 0">
              <Input v-model="item.value" placeholder="输入搜索值" />
            </div>
          </div>
        </Col>
        <Col :span="3" style="text-align: right">
          <Button type="error" @click="searchList.splice(index, 1)">删除</Button>
        </Col>
      </Row>
      <Button type="primary" @click="searchList.push({ type: 0 })" long
        >添加搜索条件</Button
      >
      <div slot="footer">
        <Button type="text" @click="searchModal = false">取消</Button>
        <Button type="primary" @click="searchOk">确定</Button>
      </div>
    </Modal>
    <agent-track
      :visible="track.visible"
      :agent_name="track.agent_name"
      :contacts_name="track.contacts_name"
      :contacts_tel="track.contacts_tel"
      :agent_id="track.agent_id"
      @cancel="track.visible = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import agentTrack from "./track.vue";
export default {
  components: { agentTrack },
  data() {
    this.searchItem = [
      { cond: "id", title: "编号" },
      { cond: "agent_name", title: "名称" },
      { cond: "tel", title: "账号" },
      /* {
        cond: "code",
        title: "云知印支持",
        select: [
          { title: "小闲", val: 'xiaoxian' },
          { title: "16进制", val: 'hex' },
        ],
      }, */
      /* {
        cond: "is_shop",
        title: "商城支持",
        select: [
          { title: "支持", val: 1 },
          { title: "不支持", val: 0 },
        ],
      }, */
      { cond: "province", title: "省" },
      { cond: "city", title: "市" },
      { cond: "area", title: "区" },
      { cond: "address", title: "地址" },
      { cond: "contacts_name", title: "联系人" },
      { cond: "contacts_tel", title: "联系电话" },
      {
        cond: "is_del",
        title: "状态",
        select: [
          { title: "正常", val: 0 },
          { title: "待审核", val: -1 },
          { title: "禁用", val: 1 },
        ],
      },
      { cond: "wx_code", title: "微信账号" },
      // { cond: "aid_extract", title: "手续费后收益" },
      // { cond: "pay_time", title: "自动转账" },
      { cond: "create_time", title: "注册时间" },
      { cond: "last_login_time", title: "最后登录时间" },
    ];
    return {
      track: {
        visible: false,
        agent_name: "",
        contacts_name: "",
        contacts_tel: "",
      },
      page: {
        p: 0,
        l: 10,
        cond: "id",
        value: "",
        is_del: 0, // 禁用列表
        senior: "",
        key: "id",
        order: "desc",
      },
      data: [],
      total: 0,
      columns: [],
      searchList: [],
      searchShow: [],
      tableLoading: false,
      searchModal: false,
      start: [
        {
          title: "编号",
          width: 100,
          key: "id",
          fixed: "left",
          sortable: "custom",
        },
      ],
      col: [
        {
          title: "名称",
          key: "agent_name",
          width: 130,
          show: true,
          fixed: "left",
          sortable: "custom",
          tooltip: true,
        },
        {
          title: "账号",
          key: "tel",
          minWidth: 110,
          show: true,
          sortable: "custom",
        },
        {
          title: "运营设备",
          key: "allMachine",
          minWidth: 100,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  padding: "2px 3px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: "machine-list",
                      params: { agent_name: data.row.agent_name },
                    });
                  },
                },
              },
              data.row.allMachine
            );
          },
        },
        {
          title: "即将到期",
          key: "soonMachine",
          minWidth: 100,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  padding: "2px 3px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: "machine-list",
                      params: { agent_name: data.row.agent_name },
                    });
                  },
                },
              },
              data.row.soonMachine
            );
          },
        },
        {
          title: "到期",
          key: "expireMachine",
          minWidth: 100,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  padding: "2px 3px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: "machine-list",
                      params: { agent_name: data.row.agent_name },
                    });
                  },
                },
              },
              data.row.expireMachine
            );
          },
        },
        {
          title: "上月印量",
          key: "total_pages",
          minWidth: 100,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  padding: "2px 3px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: "amount",
                      params: {
                        agent_name: data.row.agent_name,
                        agent_id: data.row.id,
                      },
                    });
                  },
                },
              },
              data.row.total_pages
            );
          },
        },
        {
          title: "上月收益",
          key: "job_money",
          minWidth: 100,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  padding: "2px 3px",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: "amount",
                      params: {
                        agent_name: data.row.agent_name,
                        agent_id: data.row.id,
                      },
                    });
                  },
                },
              },
              data.row.job_money
            );
          },
        },
        {
          title: "平台",
          width: 115,
          key: "code",
          show: true,
          render: (h, data) => {
            let res = [];
            if (data.row.code) {
              const types = {
                xiaoxian: "小闲",
                hex: "16进制",
              };
              res.push(
                h(
                  "span",
                  {
                    style: {
                      padding: "2px 3px",
                      borderRadius: "5px",
                      color: "#fff",
                      background: "#2d8cf0",
                      marginRight: "3px",
                    },
                  },
                  types[data.row.code]
                )
              );
            }else{
              res.push(
                h(
                  "span",
                  {

                  },
                  '-'
                )
              );
            }

            return res;
          },
        },
        {
          title: "地区",
          width: 160,
          key: "al",
          show: true,
          sortable: "custom",
          _sortKey: "province",
          render: (h, data) => {
            return h(
              "span",
              `${data.row.province || ""}-${data.row.city || ""}-${data.row.area || ""}`
            );
          },
        },
        {
          title: "地址",
          minWidth: 170,
          key: "address",
          sortable: "custom",
          show: true,
          tooltip: true,
        },
        {
          title: "联系人",
          minWidth: 90,
          key: "contacts_name",
          sortable: "custom",
          show: true,
        },
        {
          title: "联系电话",
          width: 115,
          key: "contacts_tel",
          sortable: "custom",
          show: true,
        },
        {
          title: "邮箱",
          key: "email",
          minWidth: 110,
          show: true,
          sortable: "custom",
          tooltip: true,
        },
        {
          title: "状态",
          minWidth: 80,
          key: "is_del",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  color: `${
                    data.row.is_del
                      ? data.row.is_del > 0
                        ? "#ed4014"
                        : "#ff9900"
                      : "#19be6b"
                  }`,
                },
              },
              `${data.row.is_del ? (data.row.is_del > 0 ? "禁用" : "待审核") : "启用"}`
            );
          },
        },
        /* {
          title: "微信账号",
          minWidth: 140,
          key: "wx_code",
          sortable: "custom",
          show: true,
        },
        {
          title: "手续费后收益",
          minWidth: 110,
          key: "aid_extract",
          sortable: "custom",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              `${data.row.aid_extract ? data.row.aid_extract + "%" : "暂无"}`
            );
          },
        }, */
        // { title: '自动转账',
        //   minWidth: 110,
        //   key: 'pay',
        //   show: true,
        //   sortable: 'custom',
        //   _sortKey: 'pay_time',
        //   render: (h, data) => {
        //     return h('span', {}, `${data.row.pay_auto ? '每月' + data.row.pay_time + '号' : '关闭'}`)
        //   } },
        {
          title: "备注",
          key: "note",
          _sortKey: "note",
          minWidth: 120,
          show: true,
          tooltip: true,
        },
        {
          title: "注册时间",
          key: "create_time",
          sortable: "custom",
          minWidth: 150,
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.create_time);
          },
        },
        {
          title: "最后登录时间",
          key: "last_login_time",
          sortable: "custom",
          minWidth: 150,
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.last_login_time);
          },
        },
      ],
      end: [
        {
          title: "操作",
          width: 250,
          key: "operator",
          fixed: "right",
          render: (h, data) => {
            return h("div", { style: "text-align:center" }, [
              h(
                "Button",
                {
                  props: {
                    type: `${data.row.is_del ? "success" : "error"}`,
                    size: "small",
                  },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `${
                          data.row.is_del
                            ? data.row.is_del < 0
                              ? "通过"
                              : "启用"
                            : "禁用"
                        }`,
                        content: `是否${
                          data.row.is_del
                            ? data.row.is_del < 0
                              ? "通过"
                              : "启用"
                            : "禁用"
                        }该合作伙伴`,
                        onOk: () => {
                          this.updateStatus(data.row.id, data.row.is_del !== 0 ? 0 : 1);
                        },
                      });
                    },
                  },
                },
                `${data.row.is_del ? (data.row.is_del < 0 ? "通过" : "启用") : "禁用"}`
              ),
              h(
                "Button",
                {
                  props: { type: "info", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: "重置密码",
                        content: `<p>是否重置${data.row.agent_name}密码为: 123456</p>`,
                        onOk: () => {
                          this.InitPWD({ id: data.row.user_id }).then(() => {
                            this.$Message.success("重置成功");
                          });
                        },
                      });
                    },
                  },
                },
                "重置密码"
              ),
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: "agent-edit",
                        params: { id: data.row.id },
                      });
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: { type: "success", size: "small" },
                  on: {
                    click: () => {
                      this.track = {
                        visible: true,
                        agent_name: data.row.name,
                        contacts_name: data.row.contacts_name,
                        contacts_tel: data.row.contacts_tel,
                        agent_id: data.row.id,
                      };
                    },
                  },
                },
                "记录"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getData();
    this.formatCol();
  },
  methods: {
    // 重置获取数据
    reset() {
      this.page.cond = "id";
      this.page.value = "";
      this.page.senior = "";
      this.searchList = [];
      this.searchShow = [];
      this.getData();
    },
    // 导出Excel
    exportData(is_all) {
      let title = ["编号"],
        key = ["id"];
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title);
          key.push(item.key);
        }
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "合作伙伴",
      };
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        page.p = 0;
        this.getAgentList(page).then((res) => {
          res.data.map((item) => {
            item.last_login_time = item.last_login_time
              ? this.$moment(item.last_login_time)
              : "-";
            item.create_time = this.$moment(item.create_time);
          });
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    // 导出数据格式
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        item.zc = "";
        if (item.is_aid) {
          item.zc += "云知印";
        }
        if (item.is_shop) {
          item.zc += "商城";
        }
        item.al = `${item.province}-${item.city}-${item.area}`;
        item.is_aid = item.zc;
        item.pay = item.pay_time ? `每月${item.pay_time}日` : "";
        item.aid_extract = item.aid_extract ? `${item.aid_extract}%` : "";
        item.is_del = `${item.is_del ? (item.is_del > 0 ? "禁用" : "待审核") : "启用"}`;
      });
      return result;
    },
    // 表格排序
    tableSort(col) {
      this.page.key = col.column._sortKey || col.key;
      this.page.order = col.order;
      this.getData();
    },
    // 删除显示在外部的条件
    searchShowDel(index) {
      let temp = this.page.senior.split("|||");
      temp.splice(index, 1);
      this.searchList.splice(index, 1);
      this.searchShow.splice(index, 1);
      this.page.senior = temp.join("|||");
      this.getData();
    },
    // 高级搜索模态框确定
    searchOk() {
      this.page.senior = "";
      this.searchShow = [];
      let temp = [];
      this.searchList.map((item) => {
        if (item.cond) {
          temp.push(`${item.cond}***${item.type}***${item.value}`);
          this.searchItem.map((a, b) => {
            if (a.cond === item.cond) {
              if (a.select) {
                a.select.map((s) => {
                  if (s.val === item.value) {
                    this.searchShow.push(
                      `${a.title} ${
                        item.type ? (item.type === 1 ? "包含" : "不等于") : "等于"
                      } ${s.title}`
                    );
                  }
                });
              } else {
                this.searchShow.push(
                  `${a.title} ${
                    item.type ? (item.type === 1 ? "包含" : "不等于") : "等于"
                  } ${item.value}`
                );
              }
            }
          });
        }
      });
      if (temp.length === 0) {
        this.$Message.error("未选择相应条件");
      } else {
        this.page.senior = temp.join("|||");
        this.searchModal = false;
        this.getData();
      }
    },
    // 打开高级搜索模态框
    seniorSearch() {
      this.searchModal = true;
      this.page.cond = "id";
      this.page.value = "";
    },
    getData() {
      this.tableLoading = true;
      this.getAgentList(this.page).then((res) => {
        res.data.map((item) => {
          item.last_login_time = item.last_login_time
            ? this.$moment(item.last_login_time)
            : "-";
          item.create_time = this.$moment(item.create_time);
        });
        this.data = res.data;
        this.total = res.total;
        this.tableLoading = false;
      });
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    // 修改代理商状态
    updateStatus(id, is_del) {
      this.putAgentIsDel({ id: id, is_del: is_del }).then((res) => {
        this.data.map((item, index) => {
          if (item.id === id) {
            item.is_del = is_del;
          }
        });
      });
    },
    // 格式化表格列
    formatCol() {
      let temp = [];
      this.col.map((item) => {
        if (item.show) {
          temp.push(item);
        }
      });
      this.columns = this.start.concat(temp).concat(this.end);
    },
    ...mapActions(["getAgentList", "putAgentIsDel", "InitPWD"]),
  },
  computed: mapGetters({}),
  watch: {
    col: {
      handler(n, o) {
        this.formatCol();
      },
      deep: true,
    },
    "page.is_del"(n, o) {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
